module.exports = __webpack_public_path__ + "static/media/05-checkbox-feedback.09480922.png";